export default __webpack_public_path__ + "static/media/Linkedin.0f4b57c2.svg";